import "rxjs/add/operator/map";
// Classes.
import { ResponseData } from "../fetching/wa-response/wa-api-response";
// Providers.
import { WABaseService } from "./wa-base.service";
import { LoggerService } from "../logger/logger-service";
import { EnvironmentService } from "./environment-service";
import { FactoryService } from "./factory-service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators/';
import { ParamBuilderService, ParamSpecStruct } from "./param-builder-service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../logger/logger-service";
import * as i3 from "./environment-service";
import * as i4 from "./factory-service";
import * as i5 from "./param-builder-service";
export class DataFetchService extends WABaseService {
    constructor(http, logger, env, factory, paramBuilder) {
        super(logger, env);
        this.http = http;
        this.logger = logger;
        this.env = env;
        this.factory = factory;
        this.paramBuilder = paramBuilder;
    }
    fetchHelper(params, url) {
        this.log("Fetching URL " + url + "/" + params.toString());
        const headers = new HttpHeaders().append("Client-Security-Token", "8a9aeaee-69b6-4d7b-81fa-8ca3f93adb6c");
        return (this.http
            .get(url, { headers: headers, params: params })
            .pipe(map(response => new ResponseData(response))));
    }
    /*****************************************************************************
     * Functions related to fetching
     ***************************************************************************/
    requestCategory(requestedItems, locator) {
        const paramSpecs = [new ParamSpecStruct("CatCode", "category")];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "CATEGORIES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestCountryNames(requestedItems) {
        let params = this.paramBuilder.build(null, null, requestedItems);
        params = params.append("content", "COUNTRIES");
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestRecordList(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("RecordLevel", "recordLevel"),
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("DisciplineId", "disciplineId"),
            new ParamSpecStruct("Team", "team"),
            new ParamSpecStruct("ParaArchery", "isPara"),
            new ParamSpecStruct("Historical", "isHistorical"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("SortBy", "sortrank")
        ];
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "RECORDS");
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestWCupRanking(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("DisciplineId", "discipline"),
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("Team", "team"),
            new ParamSpecStruct("Detailed", "detailed"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("SortBy", "sortrank"),
            new ParamSpecStruct('Country', 'country')
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "WORLDCUPRANKINGS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestWCupRankingCategories(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("DisciplineId", "discipline"),
            new ParamSpecStruct("Year", "year")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "WORLDCUPRANKINGSCATEGORIES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestWorldRanking(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("Date", "date"),
            new ParamSpecStruct("Team", "team"),
            new ParamSpecStruct("Detailed", "detailed"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("SortBy", "sortrank"),
            new ParamSpecStruct('Country', 'country')
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "WORLDRANKINGS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestWorldRankingCategories(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("Team", "team"),
            new ParamSpecStruct("Date", "date"),
            new ParamSpecStruct("ParaArchery", "isPara")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "WORLDRANKINGSCATEGORIES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestAthleteList(requestedItems) {
        let params = this.paramBuilder.build(null, null, requestedItems);
        params = params.append("content", "ATHLETES");
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestAthlete(locator, requestedItems) {
        const paramSpecs = [new ParamSpecStruct("Id", "athlete")];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "ATHLETEBIOGRAPHY");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestAthleteResultList(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("Id", "athlete"),
            new ParamSpecStruct("LevelId", "level"),
            new ParamSpecStruct("StartDate", "startDate"),
            new ParamSpecStruct("EndDate", "endDate"),
            new ParamSpecStruct("DisciplineId", "discipline")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "ATHLETERESULTS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestEventList(locator, requestedItems) {
        let paramSpecs = [
            new ParamSpecStruct("LevelId", "level"),
            new ParamSpecStruct("StartDate", "startDate"),
            new ParamSpecStruct("EndDate", "endDate"),
            new ParamSpecStruct("CompId", "competition"),
            new ParamSpecStruct("EventTypeId", "event"),
            new ParamSpecStruct("Country", "country"),
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("CatId", "catId"),
            new ParamSpecStruct("Featured", "featured"),
            new ParamSpecStruct("WithResults", "withRes"),
            new ParamSpecStruct("Live", "live"),
            new ParamSpecStruct("DisciplineId", "discipline"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("SortBy", "sort"),
            new ParamSpecStruct('Detailed', 'detailed'),
            new ParamSpecStruct("WorldRecordStatus", "worldrecordstatus"),
            new ParamSpecStruct("WorldRankingEvent", "worldrankingevent"),
            new ParamSpecStruct("embedFiles", "embedfiles"),
            new ParamSpecStruct('DivId', "catDivision")
        ];
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value['nameInside']));
                }
            }
        });
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "COMPETITIONS");
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestLatestNews(locator, requestedItems) {
        let endpointFragment;
        if (locator.getComponent("popular").toString() === "popular") {
            endpointFragment = "news-popular";
        }
        else {
            endpointFragment = "news";
        }
        const url = `${this.env.cmsServerURL}/api/v1.0/${endpointFragment}`;
        return this.http.get(url, {}).pipe(map((response) => {
            let items = response;
            let responseDataRaw = {
                items: items,
                pageInfo: {
                    totalResults: items.length,
                    resultsPerPage: 10,
                    page: 0
                }
            };
            return new ResponseData(responseDataRaw);
        }));
    }
    requestSeriesStage(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("DisciplineId", "discipline"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("fText", "search")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "SERIESSTAGES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestSeriesAmateursRankings(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("CatId", "catid"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("Detailed", "detailed"),
            new ParamSpecStruct("SortBy", "sortindoor")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "SERIESAMATEURSRANKINGS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestSeriesTeamRanking(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("CatId", "catid"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("SortBy", "sortindoor"),
            new ParamSpecStruct("Detailed", "detailed")
        ];
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "SERIESTEAMSRANKINGS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestWCupSeason(requestedItems) {
        let params = this.paramBuilder.build(null, null, requestedItems);
        params = params.append("content", "WORLDCUPSEASON");
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestRecordsArea(locator, requestedItems) {
        let paramSpecs = [new ParamSpecStruct("RecordLevel", "catid")];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "RECORDAREAS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        let url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestRecordHistory(locator, requestedItems) {
        let paramSpecs = [
            new ParamSpecStruct("RecordLevel", "recordLevel"),
            new ParamSpecStruct("RecordArea", "recordArea"),
            new ParamSpecStruct("RecordType", "recordType")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "RECORDHISTORY");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        let url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestSeriesList(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("DisciplineId", "discipline"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("fText", "search")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "SERIES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestSeriesProList(locator, requestedItems) {
        const paramSpecs = [
            new ParamSpecStruct("CatId", "catid"),
            new ParamSpecStruct("Year", "year"),
            new ParamSpecStruct("CatCode", "category"),
            new ParamSpecStruct("fText", "search"),
            new ParamSpecStruct("Detailed", "detailed"),
            new ParamSpecStruct("SortBy", "sortindoor"),
            new ParamSpecStruct("Team", "team")
        ];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "SERIESPRORANKINGS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestCompetitionDisciplines(locator, requestedItems) {
        const paramSpecs = [];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "COMPETITIONDISCIPLINES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestCompetitionLevels(locator, requestedItems) {
        const paramSpecs = [];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "COMPETITIONLEVELS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestDivisionCategory(requestedItems, locator) {
        const paramSpecs = [];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "DIVISIONS");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
    requestPrizeForPrecisionCategory(requestedItems, locator) {
        const paramSpecs = [new ParamSpecStruct("Year", "year")];
        let params = this.paramBuilder.build(paramSpecs, locator, requestedItems);
        params = params.append("content", "PRECISIONPRIZECATEGORIES");
        locator.getComponents().forEach(value => {
            if (value.getParam() != null) {
                const index = paramSpecs.findIndex(param => param.name === value.getParam());
                if (index === -1) {
                    this.log("WARNING, Locator " + value.toString() + " with param " + value.getParam() + " it's not fixed to request ", params);
                    paramSpecs.push(new ParamSpecStruct(value.getParam(), value.toString()));
                }
            }
        });
        const url = `${this.env.waApiServerURL}`;
        return this.fetchHelper(params, url);
    }
}
DataFetchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataFetchService_Factory() { return new DataFetchService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoggerService), i0.ɵɵinject(i3.EnvironmentService), i0.ɵɵinject(i4.FactoryService), i0.ɵɵinject(i5.ParamBuilderService)); }, token: DataFetchService, providedIn: "root" });
